import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { produce } from 'immer';
export const EMBED_LOCALSTORAGE_KEY = 'academy:embedTab';
export const useEmbedState = create()(persist(set => ({
  selectedTabId: 'iframe',
  iframeName: 'HubSpot Academy Video',
  variant: 'default',
  authType: 'app',
  setSelectedTabId: tabId => set(produce(state => {
    state.selectedTabId = tabId;
  })),
  setIframeName: name => set(produce(state => {
    state.iframeName = name;
  })),
  setVariant: variant => set(produce(state => {
    state.variant = variant;
  })),
  setAuthType: authType => set(produce(state => {
    state.authType = authType;
  }))
}), {
  name: EMBED_LOCALSTORAGE_KEY
}));